'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hover = require('./hover');

var _hover2 = _interopRequireDefault(_hover);

var _opacity = require('../../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Error = function (_React$Component) {
    _inherits(Error, _React$Component);

    function Error() {
        _classCallCheck(this, Error);

        return _possibleConstructorReturn(this, (Error.__proto__ || Object.getPrototypeOf(Error)).apply(this, arguments));
    }

    _createClass(Error, [{
        key: 'getIcon',
        value: function getIcon(primary, size) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 48 48' },
                _react2.default.createElement(
                    'g',
                    { transform: 'translate(-0.204)' },
                    _react2.default.createElement('rect', { fill: 'transparent', width: size, height: size, transform: 'translate(0.204)' }),
                    _react2.default.createElement('path', { fill: primary, opacity: _opacity2.default.Light, fillRule: 'evenodd', d: 'M23.753,9.179l-18.1,35.3a2.541,2.541,0,0,0,.8,3.2,1.848,1.848,0,0,0,1,.3h35.9A2.216,2.216,0,0,0,45.4,45.619a2.615,2.615,0,0,0-.3-1.226L27.293,9.1a1.905,1.905,0,0,0-2.817-.78A2.243,2.243,0,0,0,23.753,9.179Z', transform: 'translate(-1.149 -4)' }),
                    _react2.default.createElement('path', { fill: primary, d: 'M-935.8-1397a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1-935.8-1397Zm0-6v-10a2,2,0,0,1,2-2,2,2,0,0,1,2,2v10a2,2,0,0,1-2,2A2,2,0,0,1-935.8-1403Z', transform: 'translate(958 1431)' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var size = this.props.size || 24;
            switch (this.props.mode) {
                case 'hover':
                    return _react2.default.createElement(_hover2.default, { size: this.props.size });
                case 'warning':
                    return this.getIcon(_colors.Colors.Warning, size);
                case 'inactive':
                case 'error':
                default:
                    return this.getIcon(_colors.Colors.Error, size);
            }
        }
    }]);

    return Error;
}(_react2.default.Component);

exports.default = Error;